import { Box } from '@mui/material'
import { BetDetailsTableComponent } from '@/views/components'
import { useTransactionBetDetails } from '@/views/transactions/hooks'

type Props = {
  transactionId: number
}

export const TransactionsBetDetailsReport = ({ transactionId }: Props) => {
  const { sortedRows, createSortHandler, order, orderBy, headCells } =
    useTransactionBetDetails({ transactionId })

  return (
    <Box width="100%" margin="40px auto">
      <Box overflow="hidden">
        <BetDetailsTableComponent
          sortedRows={sortedRows}
          order={order}
          orderBy={orderBy}
          createSortHandler={createSortHandler}
          headCells={headCells}
        />
      </Box>
    </Box>
  )
}
